import React from 'react';

/**
 * PaginationControls - Reusable pagination controls component
 * 
 * @param {Object} props - Component props
 * @param {number} props.currentPage - Current page number (1-based)
 * @param {number} props.totalPages - Total number of pages
 * @param {Function} props.onPrevious - Called when Previous button is clicked
 * @param {Function} props.onNext - Called when Next button is clicked
 * @param {number} [props.totalItems=0] - Total number of items
 * @param {number} [props.itemsPerPage=25] - Items per page
 * @param {number} [props.currentItemsCount=0] - Number of items on current page
 * @param {string} [props.itemType='items'] - Type of items for display text (e.g., 'users', 'organizations')
 * @param {boolean} [props.showItemCount=true] - Whether to show item count display
 * @returns {React.ReactElement} Pagination controls component
 */
const PaginationControls = ({
  currentPage,
  totalPages,
  onPrevious,
  onNext,
  totalItems = 0,
  itemsPerPage = 25,
  currentItemsCount = 0,
  itemType = 'items',
  showItemCount = true
}) => {
  const startItem = totalItems === 0 ? 0 : (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(totalItems, currentPage * itemsPerPage);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'space-between', 
      alignItems: 'center', 
      padding: '0.5rem 0.75rem', 
      borderTop: '1px solid var(--border)', 
      background: 'var(--bg-secondary)', 
      fontSize: '0.85rem' 
    }}>
      {showItemCount && (
        <span style={{ color: 'var(--text-secondary)' }}>
          Showing {startItem} to {endItem} of {totalItems} {itemType}
        </span>
      )}
      <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
        <button 
          disabled={currentPage === 1}
          onClick={onPrevious}
          className="btn-secondary"
          style={{ padding: '4px 12px', fontSize: '0.8rem', cursor: 'pointer' }}
        >
          Previous
        </button>
        <span style={{ fontWeight: 600, color: 'var(--text-primary)' }}>
          Page {currentPage} of {totalPages}
        </span>
        <button 
          disabled={currentPage === totalPages}
          onClick={onNext}
          className="btn-secondary"
          style={{ padding: '4px 12px', fontSize: '0.8rem', cursor: 'pointer' }}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default PaginationControls;